import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import HomeMobile from './../components/HomeMobile';
import {
  getGames,
  filterGames,
  getUpdatedGames
} from '../actions/gamesActions';
import { getUmpInfo } from '../actions/umpireActions';
import { getSeasonDivisions } from '../actions/divisionsActions';
import { getCoachesTeams } from '../actions/coachActions';
import { getTeamsVolunteering } from '../actions/teamActions';
import { clearErrors } from '../actions/errorActions';
import { updateMobileState } from '../actions/mobileActions';
import { changeUserSeason } from '../actions/userActions';

const mapDispatchToProps = dispatch => {
  return {
    getGames: (startDate, numRows, lastStartDate, lastGameId) => {
      dispatch(getGames(startDate, numRows, lastStartDate, lastGameId));
    },
    getUmpire: memberId => {
      dispatch(getUmpInfo(memberId));
    },
    filterGames: (startDate, endDate, season, division, team, umpire, showAllGames, limitResults) => {
      dispatch(filterGames(startDate, endDate, season, division, team, umpire, showAllGames, limitResults));
    },
    getSeasonDivisions: (seasonId) => {
      dispatch(getSeasonDivisions(seasonId));
    },
    clearErrors: () => {
      dispatch(clearErrors());
    },
    getCoachesTeams: (memberId, seasonId) => {
      dispatch(getCoachesTeams(memberId, seasonId));
    },
    getTeamsVolunteering: (memberId, seasonId) => {
      dispatch(getTeamsVolunteering(memberId, seasonId));
    },
    getUpdatedGames: (startDate, numRows, lastStartDate, lastGameId) => {
      dispatch(getUpdatedGames(startDate, numRows, lastStartDate, lastGameId));
    },
    updateMobileState: (mobile) =>{
      dispatch(updateMobileState(mobile));
    },
    changeUserSeason: (seasonId) => {
      dispatch(changeUserSeason(seasonId));
    }
  };
};
const mapStateToProps = state => {
  return {
    seasons: state.seasons.seasons,
    seasonsList: state.seasons.seasonsList,
    fetchingSeasonsStatus: state.seasons.fetchingSeasonsStatus,
    seasonDivisions: state.divisions.seasonDivisions,
    seasonDivisionsList: state.divisions.seasonDivisionsList,
    fetchingSeasonDivisionsStatus: state.divisions.fetchingSeasonDivisionsStatus,
    games: state.games.games,
    gamesList: state.games.gamesList,
    fetchingGamesStatus: state.games.fetchingGamesStatus,
    filteredGamesList: state.games.filteredGamesList,
    fetchingFilteredGamesStatus: state.games.fetchingFilteredGamesStatus,
    userType: state.user.userType,
    memberId: state.user.memberId,
    umpires: state.umpires.umpires,
    umpiresList: state.umpires.umpiresList,
    umpiresFetchStatus: state.umpires.umpiresFetchStatus,
    error: state.errors.error,
    teamsCoaching: state.user.teamsCoaching,
    fetchingCoachTeamsStatus: state.user.fetchingCoachTeamsStatus,
    teamsVolunteering: state.user.teamsVolunteering,
    fetchingTeamsVolunteering: state.user.teamsVolunteeringStatus,
    updateUmpireStatus: state.games.updateUmpireStatus,
    umpireLevel: state.user.umpireLevel,
    mobile: state.mobile.mobile,
    userSeason: state.user.userSeason
  };
};

const HomeMobileContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(HomeMobile));
export default HomeMobileContainer;


// WEBPACK FOOTER //
// ./src/containers/HomeMobileContainer.js